export default "__VITE_ASSET__BkM7845T__"